import React, { useState, useEffect } from "react";
import "./styles.scss";
import Products from "../../component/bundleList/productDetails";
import TitleSlider from "../../component/bundleList/titleSlider";
import ProductSlider from "../../component/bundleList/productSlider";
import ProductDescription from "../../component/bundleList/productsDescription";
import { useNavigate } from "react-router-dom";

import { ReactComponent as Backbtn } from "../../assets/icons/backbtn.svg";
import {
  getBundleDetails,
  postProductAddedBundle,
  getCartList,
} from "../../store/homeAction/action";

import { useStateValue } from "../../store/index";
import NeedHelp from "../../component/score/needHelp";
import InstallationRequirement from "../../component/bundleList/installationRequirement";
import Button from "../../common/button";

const BundleListing = () => {
  const [{ bundleDetail }, dispatch] = useStateValue();
  const [bundleProductData, setBundleProductData] = useState([]);
  const [allSelectedVariant, setAllSelectedVariant] = useState({});
  const Navigate = useNavigate();
  useEffect(() => {
    dispatch({
      type: "SET_IS_LOADING",
      value: true,
    });

    let scoreData = JSON.parse(sessionStorage.getItem("risk_score"));
    let layoutData = JSON.parse(sessionStorage.getItem("choose_layout"));
    let bundleListData = JSON.parse(sessionStorage.getItem("user_bundle"));

    const payload = {
      filter_data: [
        {
          taxonomy: "pa_score-level",
          field: "name",
          terms: scoreData?.risk_level,
        },
        {
          taxonomy: layoutData?.taxonomy,
          field: "name",
          terms: layoutData?.title,
        },
        {
          taxonomy: bundleListData?.taxonomy,
          field: "name",
          terms: bundleListData?.title,
        },
      ],
    };
    getBundleDetails((res, error) => {
      dispatch({
        type: "SET_BUNDLE_DETAIL",
        data: res,
      });

      if (res?.product_data) {
        let temp = res?.product_data?.map((item) => {
          const tempData = {};
          const keyVariant = [];
          item?.attributes?.length &&
            item?.attributes?.forEach((i) => {
              let key_varaint_id = "";

              item?.variants?.forEach((ite) => {
                ite?.variation_attributes?.forEach((itm) => {
                  if (
                    itm?.attribute_name === i?.attribute_name &&
                    // keyVariant.includes(ite?.variation_id) &&
                    ite?.variation_id
                  ) {
                    keyVariant.push(ite?.variation_id);
                    key_varaint_id = ite?.variation_id;
                  }
                });
              });
              const keyName = `${i?.attribute_name}__${
                i?.attribute_type || ""
              }`;
              tempData[keyName] = tempData[keyName] || [];
              tempData[keyName].push({ ...i?.options, key_varaint_id });
            });
          return { ...item, attributes: tempData, keyVariant: keyVariant };
        });
        setBundleProductData(temp);
      }
      dispatch({
        type: "SET_IS_LOADING",
        value: false,
      });
      if (error) {
        dispatch({
          type: "SET_ALERT_MESSAGE",
          value: true,
          data: {
            severity: "error",
            message: "Something went wrong, Please try again.",
          },
        });
      }
    }, payload);
  }, []);

  //get variant with price
  const handleSelectedVariant = (value) => {
    const updatedVariants = {
      ...allSelectedVariant,
      [value.index]: value.selectedVariant,
    };
    const arrayOfObjects = Object.entries(updatedVariants).map(
      ([key, value]) => ({ key, ...value })
    );
    setAllSelectedVariant(arrayOfObjects);
    sessionStorage.setItem("bundle_detail", JSON.stringify(arrayOfObjects));
  };

  const defaultSelectVariant = {};
  const handleDefaultVariant = (value) => {
    defaultSelectVariant[value.index] = value.selectedVariant;
    setTimeout(() => {
      const arrayOfObjects = Object.entries(defaultSelectVariant).map(
        ([key, value]) => ({
          key,
          ...value,
        })
      );
      setAllSelectedVariant(arrayOfObjects);
      sessionStorage.setItem("bundle_detail", JSON.stringify(arrayOfObjects));
    }, 100);
  };

  const handleAddCart = () => {
    let userBundle = JSON.parse(sessionStorage.getItem("user_bundle"));
    let sessionKey = sessionStorage.getItem("session_key");
    let payload = {
      terms: userBundle?.title,
      products: [],
    };
    payload.session_key = sessionKey ?? null;

    if (allSelectedVariant?.length) {
      allSelectedVariant.forEach((item) => {
        payload.products.push({
          product_id: item?.product_id,
          variant_id: item?.variation_id,
        });
      });
    }

    if (payload?.products?.length > 0) {
      dispatch({
        type: "SET_IS_LOADING",
        value: true,
      });
      postProductAddedBundle((res, error) => {
        if (res?.datas?.session_key) {
          sessionStorage.setItem("session_key", res?.datas?.session_key);
        }
        dispatch({
          type: "SET_CART_ALERT",
          value: true,
          data: {
            identity: "bundle",
            ...res?.datas,
            message: res?.message,
            error,
          },
        });
        let payload = {
          session_key: sessionStorage.getItem("session_key"),
        };
        getCartList((res, error) => {
          dispatch({
            type: "SET_CARTLIST_DATA",
            data: res,
          });
          sessionStorage.setItem(
            "iszipAuth",
            res?.data?.installation_content?.postal_code
          );
          dispatch({
            type: "SET_ZIP_CODE_POPUP",
            value: false,
            data: {
              installation: res?.data?.installation_content?.installation,
              fall_prevention: res?.data?.installation_content?.fall_prevention,
              zipCode: res?.data?.installation_content?.postal_code,
            },
          });
          dispatch({
            type: "SET_IS_LOADING",
            value: false,
          });
        }, payload);
      }, payload);
    } else {
      dispatch({
        type: "SET_ALERT_MESSAGE",
        value: true,
        data: {
          severity: "error",
          message: "No bundle found to add to cart.",
        },
      });
    }
  };
  return (
    <div className="bundle-listing-container">
      <Backbtn onClick={() => Navigate(-1)} className="back-btn" />
      <TitleSlider
        {...bundleDetail?.bundle_contents}
        allSelectedVariant={allSelectedVariant}
      />
      <ProductSlider data={bundleDetail?.carousel_images} />
      {bundleDetail?.bundle_contents &&
      Object.keys(bundleDetail?.bundle_contents)?.length !== 0 ? (
        <ProductDescription
          {...bundleDetail?.bundle_contents}
          data={bundleDetail?.page_contents}
        />
      ) : null}
      {bundleProductData?.map((item, index) => {
        return (
          <Products
            item={item}
            index={index}
            handleSelectedVariant={handleSelectedVariant}
            handleDefaultVariant={handleDefaultVariant}
            className="bundle-product-container"
          />
        );
      })}
      {bundleDetail?.installation?.installation_requirements &&
      Object.keys(bundleDetail?.installation?.installation_requirements)
        ?.length !== 0 ? (
        <InstallationRequirement
          data={{
            description: bundleDetail?.installation?.installation_requirements,
            checked_content: bundleDetail?.installation?.installation,
            price: bundleDetail?.installation?.install_price,
            currency_symbol: bundleDetail?.installation?.currency_symbol,
            title: "Installation Requirements",
          }}
          checked={true}
          identity="installation"
        />
      ) : null}
      {bundleDetail?.installation?.fall_prevention_program &&
      Object.keys(bundleDetail?.installation?.fall_prevention_program)
        ?.length !== 0 ? (
        <InstallationRequirement
          data={{
            description: bundleDetail?.installation?.fall_prevention_program,
            checked_content: bundleDetail?.installation?.home_consultation,
            title: "Fall Prevention Program",
          }}
          checked={true}
          identity="fall_prevention"
        />
      ) : null}
      {bundleProductData?.length ? (
        <div className="add-bundle-btn">
          <Button onClick={() => handleAddCart()}>Add bundle to cart</Button>
        </div>
      ) : null}

      {bundleDetail?.helping_section?.length &&
      Object.keys(bundleDetail?.helping_section?.[0])?.length !== 0 ? (
        <NeedHelp {...bundleDetail?.helping_section?.[0]} />
      ) : null}
    </div>
  );
};

export default BundleListing;
